import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Icon,
  Button,
} from '..';

function ArrowButton({
  type,
  isLeft,
  className,
  children,
  onClick,
}) {
  return (
    <Button
      type={type}
      className={classnames('btn-arrow', className)}
      onClick={onClick}
    >
      { isLeft && <Icon type="chevron-left" /> }
      { isLeft && children }
      { !isLeft && children }
      { !isLeft && <Icon type="chevron-right" /> }
    </Button>
  );
}

ArrowButton.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node,
  isLeft: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default ArrowButton;
